import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import API_CONFIG from '../config/api';

const SignInPage = () => {
  const handleSignIn = () => {
    const frontendOrigin = encodeURIComponent(window.location.origin);
    // Redirect to backend OAuth start endpoint
    const authUrl = `${API_CONFIG.API_BASE_URL_FULL.replace('/api', '')}/auth/google/start?source=web&frontendOrigin=${frontendOrigin}`;
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center">
            <img
              src="/icon.png"
              alt="Traffic Lite logo"
              className="h-16 w-16 object-contain"
            />
          </div>
          <CardTitle className="text-3xl font-bold text-gray-900">
            Traffic Lite
          </CardTitle>
          <CardDescription className="text-lg text-gray-600 mt-2">
            Sign in with your Google account to get started
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <Button 
            onClick={handleSignIn}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-lg"
            size="lg"
          >
            Sign in with Google
          </Button>
          
          <div className="text-center pt-4 border-t">
            <p className="text-sm text-gray-500">
              AI Policy Governance for Schools, Embedded in Google Classroom
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SignInPage;
